import { useUpdateFilters } from '@services/filters/update';
import { useFilterKey } from './useFilterKey';
import { Filters } from '@services/filters/types';
import { useAppContext } from '@contexts/app';
import isEqual from 'deep-equal';
import { QueryParam, QueryParams } from './queryParams/types';

const EXCLUDED_KEYS: QueryParam[] = ['date', 'tab', 'page', 'focus', 'auth', 'open'] as const;

export const useSaveFilters = () => {
  const key = useFilterKey();
  const { mutate } = useUpdateFilters();
  const { filters } = useAppContext();

  return (newFilters: QueryParams) => {
    const params = newFilters;

    EXCLUDED_KEYS.forEach((el) => {
      if (!params[el]) return;
      delete params[el];
    });

    Object.keys(params).forEach((el) => {
      const paramKey = el as keyof QueryParams;
      if (!params[paramKey]?.length) delete params[paramKey];
    });

    if (!filters || !key || isEqual(filters?.[key], params)) return;
    mutate({ data: { ...filters, [key]: params } as Filters });
  };
};
